export const menuItems = [
	{
		labelDictionaryKey: "HeaderSection1Text",
		linkDictionaryKey: "HeaderSection1Url",
		attrDictionaryKey: "HeaderSection1TitleAttribute",
		useRouter: true,
		navLink: true,
		eventID: 6,
	},
	{
		labelDictionaryKey: "HeaderSection2Text",
		linkDictionaryKey: "HeaderSection2Url",
		attrDictionaryKey: "HeaderSection2TitleAttribute",
		useRouter: true,
		navLink: true,
		gaEventAction: "WWF Cheat",
		eventID: 10,
	},
	{
		labelDictionaryKey: "HeaderSection3Text",
		linkDictionaryKey: null,
		attrDictionaryKey: "HeaderSection3TitleAttribute",
		eventID: 7,
		submenu: [
			{
				labelDictionaryKey: "HeaderSection3Subsection1Text",
				linkDictionaryKey: "HeaderSection3Subsection1Url",
				attrDictionaryKey: "HeaderSection3Subsection1TitleAttribute",
				eventID: 26,
			},
			{
				labelDictionaryKey: "HeaderSection3Subsection2Text",
				linkDictionaryKey: "HeaderSection3Subsection2Url",
				attrDictionaryKey: "HeaderSection3Subsection2TitleAttribute",
				eventID: 25,
			},
			{
				labelDictionaryKey: "HeaderSection3Subsection3Text",
				linkDictionaryKey: "HeaderSection3Subsection3Url",
				attrDictionaryKey: "HeaderSection3Subsection3TitleAttribute",
				eventID: 23,
			},
			{
				labelDictionaryKey: "HeaderSection3Subsection4Text",
				linkDictionaryKey: "HeaderSection3Subsection4Url",
				attrDictionaryKey: "HeaderSection3Subsection4TitleAttribute",
				eventID: 22,
			},
			{
				labelDictionaryKey: "HeaderSection3Subsection5Text",
				linkDictionaryKey: "HeaderSection3Subsection5Url",
				attrDictionaryKey: "HeaderSection3Subsection5TitleAttribute",
				eventID: 19,
			},
			{
				labelDictionaryKey: "HeaderSection3Subsection6Text",
				linkDictionaryKey: "HeaderSection3Subsection6Url",
				attrDictionaryKey: "HeaderSection3Subsection6TitleAttribute",
				eventID: 16,
			},
			{
				labelDictionaryKey: "HeaderSection3Subsection7Text",
				linkDictionaryKey: "HeaderSection3Subsection7Url",
				attrDictionaryKey: "HeaderSection3Subsection7TitleAttribute",
				eventID: 24,
			},
			{
				labelDictionaryKey: "HeaderSection3Subsection8Text",
				linkDictionaryKey: "HeaderSection3Subsection8Url",
				attrDictionaryKey: "HeaderSection3Subsection8TitleAttribute",
				eventID: 27,
			},
			{
				labelDictionaryKey: "HeaderSection3Subsection9Text",
				linkDictionaryKey: "HeaderSection3Subsection9Url",
				attrDictionaryKey: "HeaderSection3Subsection9TitleAttribute",
				eventID: 15,
			},
		],
	},
	{
		labelDictionaryKey: "HeaderSection5Text",
		linkDictionaryKey: null,
		attrDictionaryKey: "HeaderSection5TitleAttribute",
		eventID: 4,
		submenu: [
			{
				labelDictionaryKey: "HeaderSection5Subsection1Text",
				linkDictionaryKey: "HeaderSection5Subsection1Url",
				attrDictionaryKey: "HeaderSection5Subsection1TitleAttribute",
				eventID: 21,
			},
			{
				labelDictionaryKey: "HeaderSection5Subsection2Text",
				linkDictionaryKey: "HeaderSection5Subsection2Url",
				attrDictionaryKey: "HeaderSection5Subsection2TitleAttribute",
				eventID: 13,
			},
			{
				labelDictionaryKey: "HeaderSection5Subsection3Text",
				linkDictionaryKey: "HeaderSection5Subsection3Url",
				attrDictionaryKey: "HeaderSection5Subsection3TitleAttribute",
				eventID: 18,
			},
			{
				labelDictionaryKey: "HeaderSection5Subsection4Text",
				linkDictionaryKey: "HeaderSection5Subsection4Url",
				attrDictionaryKey: "HeaderSection5Subsection4TitleAttribute",
				eventID: 17,
			},
			{
				labelDictionaryKey: "HeaderSection5Subsection5Text",
				linkDictionaryKey: "HeaderSection5Subsection5Url",
				attrDictionaryKey: "HeaderSection5Subsection5TitleAttribute",
				eventID: 20,
			},
			{
				labelDictionaryKey: "HeaderSection5Subsection6Text",
				linkDictionaryKey: "HeaderSection5Subsection6Url",
				attrDictionaryKey: "HeaderSection5Subsection6TitleAttribute",
				eventID: 14,
			},
		],
	},
	{
		labelDictionaryKey: "HeaderArticlesIndexText",
		linkDictionaryKey: "HeaderSection4Url",
		attrDictionaryKey: "HeaderSection4TitleAttribute",
		useRouter: true,
		eventID: 1,
		cssClass: "hide-on-desktop",
	},
	{
		labelDictionaryKey: "HeaderSection6Text",
		linkDictionaryKey: "HeaderSection6Url",
		attrDictionaryKey: "HeaderSection6TitleAttribute",
		headerDisclaimer: "HeaderNewDisclaimer",
		useRouter: true,
		cssClass: "has-disclaimer hide-on-desktop",
		eventID: 5,
	},
	{
		accountButtons: true,
		cssClass: "buttons-item",
	},
	{
		imageUrl: "/static-wf/images/ic_yd_wordscapes.png",
		imageUrlWebp: "/static-wf/images/ic_yd_wordscapes.webp",
		labelDictionaryKey: "Wordscapes",
		linkDictionaryKey: "HeaderSectionUrlWordscapes",
		attrDictionaryKey: "HeaderSectionTitleAttributeWordscapes",
		altTextDictionaryKey: "HeaderSectionTextWordscapes",
		ariaLabelDictionaryKey: "HeaderSectionAriaLabelWordscapes",
		navLink: true,
		cssClass: "other-links-start",
		gaEventLabel: "Wordscapes Logo",
		eventID: 9,
	},
	{
		imageUrl: "/static-wf/images/ic_wf_header.png",
		imageUrlWebp: "/static-wf/images/ic_wf_header.webp",
		labelDictionaryKey: "EsWfLogoText",
		linkDictionaryKey: "EsWfLogoUrl",
		attrDictionaryKey: "EsWfLogoTitleAttribute",
		altTextDictionaryKey: "EsWfLogoAltText",
		ariaLabelDictionaryKey: "EsWfLogoAriaLabel",
		navLink: true,
		gaEventLabel: "ES WF Logo",
		gaEventAction: "ES WF Logo",
		eventID: 3,
	},
	{
		imageUrl: "/static-wf/images/ic_yd_header.png",
		imageUrlWebp: "/static-wf/images/ic_yd_header.webp",
		labelDictionaryKey: "YdrLogoText",
		linkDictionaryKey: "HeaderYdrUrl",
		attrDictionaryKey: "HeaderYdrTitleAttribute",
		altTextDictionaryKey: "HeaderYdrLogoAltText",
		ariaLabelDictionaryKey: "HeaderYdrAriaLabel",
		navLink: true,
		gaEventLabel: "YDR Logo",
		gaEventAction: "YDR Logo",
		eventID: 11,
	},
];

export const menuItemsDesktop = [
	{
		labelDictionaryKey: "HeaderSection1Text",
		linkDictionaryKey: "HeaderSection1Url",
		attrDictionaryKey: "HeaderSection1TitleAttribute",
		useRouter: true,
		navLink: true,
		eventID: 6,
	},
	{
		labelDictionaryKey: "HeaderSection2Text",
		linkDictionaryKey: "HeaderSection2Url",
		attrDictionaryKey: "HeaderSection2TitleAttribute",
		useRouter: true,
		navLink: true,
		cssClass: "has-hint",
		gaEventAction: "WWF Cheat",
		eventID: 10,
	},
	{
		labelDictionaryKey: "HeaderSection7Text",
		linkDictionaryKey: null,
		attrDictionaryKey: "HeaderSection7TitleAttribute",
		navLink: true,
		eventID: 28,
		submenu: [
			[
				{
					labelDictionaryKey: "HeaderSection3Text",
					linkDictionaryKey: "HeaderSection3Subsection9Url",
					attrDictionaryKey: "HeaderSection3TitleAttribute",
					eventID: 7,
					cssClass: "submenu-link",
				},
				{
					labelDictionaryKey: "HeaderSection3Subsection1Text",
					linkDictionaryKey: "HeaderSection3Subsection1Url",
					attrDictionaryKey:
						"HeaderSection3Subsection1TitleAttribute",
					eventID: 26,
				},
				{
					labelDictionaryKey: "HeaderSection3Subsection2Text",
					linkDictionaryKey: "HeaderSection3Subsection2Url",
					attrDictionaryKey:
						"HeaderSection3Subsection2TitleAttribute",
					eventID: 25,
				},
				{
					labelDictionaryKey: "HeaderSection3Subsection3Text",
					linkDictionaryKey: "HeaderSection3Subsection3Url",
					attrDictionaryKey:
						"HeaderSection3Subsection3TitleAttribute",
					eventID: 23,
				},
				{
					labelDictionaryKey: "HeaderSection3Subsection4Text",
					linkDictionaryKey: "HeaderSection3Subsection4Url",
					attrDictionaryKey:
						"HeaderSection3Subsection4TitleAttribute",
					eventID: 22,
				},
				{
					labelDictionaryKey: "HeaderSection3Subsection5Text",
					linkDictionaryKey: "HeaderSection3Subsection5Url",
					attrDictionaryKey:
						"HeaderSection3Subsection5TitleAttribute",
					eventID: 19,
				},
				{
					labelDictionaryKey: "HeaderSection3Subsection6Text",
					linkDictionaryKey: "HeaderSection3Subsection6Url",
					attrDictionaryKey:
						"HeaderSection3Subsection6TitleAttribute",
					eventID: 16,
				},
				{
					labelDictionaryKey: "HeaderSection3Subsection7Text",
					linkDictionaryKey: "HeaderSection3Subsection7Url",
					attrDictionaryKey:
						"HeaderSection3Subsection7TitleAttribute",
					eventID: 24,
				},
				{
					labelDictionaryKey: "HeaderSection3Subsection8Text",
					linkDictionaryKey: "HeaderSection3Subsection8Url",
					attrDictionaryKey:
						"HeaderSection3Subsection8TitleAttribute",
					eventID: 27,
				},
				{
					labelDictionaryKey: "HeaderSection3Subsection9Text",
					linkDictionaryKey: "HeaderSection3Subsection9Url",
					attrDictionaryKey:
						"HeaderSection3Subsection9TitleAttribute",
					eventID: 15,
				},
			],
			[
				{
					labelDictionaryKey: "HeaderSection5Text",
					linkDictionaryKey: "HeaderSection5Subsection6Url",
					attrDictionaryKey: "HeaderSection5TitleAttribute",
					eventID: 4,
					cssClass: "submenu-link",
				},
				{
					labelDictionaryKey: "HeaderSection5Subsection1Text",
					linkDictionaryKey: "HeaderSection5Subsection1Url",
					attrDictionaryKey:
						"HeaderSection5Subsection1TitleAttribute",
					eventID: 21,
				},
				{
					labelDictionaryKey: "HeaderSection5Subsection2Text",
					linkDictionaryKey: "HeaderSection5Subsection2Url",
					attrDictionaryKey:
						"HeaderSection5Subsection2TitleAttribute",
					eventID: 13,
				},
				{
					labelDictionaryKey: "HeaderSection5Subsection3Text",
					linkDictionaryKey: "HeaderSection5Subsection3Url",
					attrDictionaryKey:
						"HeaderSection5Subsection3TitleAttribute",
					eventID: 18,
				},
				{
					labelDictionaryKey: "HeaderSection5Subsection4Text",
					linkDictionaryKey: "HeaderSection5Subsection4Url",
					attrDictionaryKey:
						"HeaderSection5Subsection4TitleAttribute",
					eventID: 17,
				},
				{
					labelDictionaryKey: "HeaderSection5Subsection5Text",
					linkDictionaryKey: "HeaderSection5Subsection5Url",
					attrDictionaryKey:
						"HeaderSection5Subsection5TitleAttribute",
					eventID: 20,
				},
				{
					labelDictionaryKey: "HeaderSection5Subsection6Text",
					linkDictionaryKey: "HeaderSection5Subsection6Url",
					attrDictionaryKey:
						"HeaderSection5Subsection6TitleAttribute",
					eventID: 14,
				},
				{
					labelDictionaryKey: "HeaderArticlesIndexText",
					linkDictionaryKey: "HeaderSection4Url",
					attrDictionaryKey: "HeaderSection4TitleAttribute",
					useRouter: true,
					cssClass: "submenu-link",
					eventID: 1,
				},
				{
					labelDictionaryKey: "HeaderSection6Text",
					linkDictionaryKey: "HeaderSection6Url",
					attrDictionaryKey: "HeaderSection6TitleAttribute",
					useRouter: true,
					cssClass: "submenu-link",
					eventID: 5,
				},
			],
		],
	},
	{
		accountButtons: true,
		cssClass: "buttons-item",
	},
	{
		imageUrl: "/static-wf/images/ic_yd_wordscapes.png",
		imageUrlWebp: "/static-wf/images/ic_yd_wordscapes.webp",
		labelDictionaryKey: "Wordscapes",
		linkDictionaryKey: "HeaderSectionUrlWordscapes",
		attrDictionaryKey: "HeaderSectionTitleAttributeWordscapes",
		altTextDictionaryKey: "HeaderSectionTextWordscapes",
		ariaLabelDictionaryKey: "HeaderSectionAriaLabelWordscapes",
		navLink: true,
		cssClass: "other-links-start",
		gaEventLabel: "Wordscapes Logo",
		eventID: 9,
	},
	{
		imageUrl: "/static-wf/images/ic_wf_header.png",
		imageUrlWebp: "/static-wf/images/ic_wf_header.webp",
		labelDictionaryKey: "EsWfLogoText",
		linkDictionaryKey: "EsWfLogoUrl",
		attrDictionaryKey: "EsWfLogoTitleAttribute",
		altTextDictionaryKey: "EsWfLogoAltText",
		ariaLabelDictionaryKey: "EsWfLogoAriaLabel",
		navLink: true,
		gaEventLabel: "ES WF Logo",
		gaEventAction: "ES WF Logo",
		eventID: 3,
	},
	{
		imageUrl: "/static-wf/images/ic_yd_header.png",
		imageUrlWebp: "/static-wf/images/ic_yd_header.webp",
		labelDictionaryKey: "YdrLogoText",
		linkDictionaryKey: "HeaderYdrUrl",
		attrDictionaryKey: "HeaderYdrTitleAttribute",
		altTextDictionaryKey: "HeaderYdrLogoAltText",
		ariaLabelDictionaryKey: "HeaderYdrAriaLabel",
		navLink: true,
		gaEventLabel: "YDR Logo",
		gaEventAction: "YDR Logo",
		eventID: 11,
	},
];
